import { render, staticRenderFns } from "./serviceTitle.vue?vue&type=template&id=26c90690&scoped=true&"
import script from "./serviceTitle.vue?vue&type=script&lang=js&"
export * from "./serviceTitle.vue?vue&type=script&lang=js&"
import style0 from "./serviceTitle.vue?vue&type=style&index=0&id=26c90690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c90690",
  null
  
)

export default component.exports